export default {
  patientCareCoordinatorsList:null,
  latestHealthTeam:null,
  deletePatientCareCoordinator:null,
  physiciansList:null,
  latestPhysician:null,
  latestCareCoordinator:null,
  patientCareCoordinatorDetails:null,
  updatePatientCareCoordinator:null,
}